import { render, staticRenderFns } from "./BpDialog.vue?vue&type=template&id=4d2c76c6&scoped=true&"
import script from "./BpDialog.vue?vue&type=script&lang=js&"
export * from "./BpDialog.vue?vue&type=script&lang=js&"
import style0 from "./BpDialog.vue?vue&type=style&index=0&id=4d2c76c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c76c6",
  null
  
)

export default component.exports